// From https://github.com/ittus/vue-long-click/blob/master/src/directives/longclick.js

import { getUserAgentObject } from '../lib/ua'
import { isFunctionType } from '../lib/utils'

const stopEventPropagation = function(event) {
  event.preventDefault()
  event.stopPropagation()
  event.cancelBubble = true
  event.returnValue = false
}

let timeout = null

export default ({ delayBeforeStart = 1000, delayBeforeEnd = 5000 }) => ({
  bind: function(el, binding, vNode) {
    let recordStartTime = null

    /**
     * Call startClick event
     * @param {Event} event
     */
    const start = event => {
      if (event.type === 'click' && event.button !== 0) {
        return
      }

      stopEventPropagation(event)

      if (binding.value.startClick && isFunctionType(binding.value.startClick, vNode)) {
        recordStartTime = new Date().getTime()
        binding.value.startClick()
      }
    }

    /**
     *  Call stopClick on cancel, and stopClickWithDelay event after delayBeforeEnd
     *  or stopShortClick if click started less than delayBeforeStart
     */
    const cancel = event => {
      if (recordStartTime === null) {
        return
      }

      stopEventPropagation(event)

      const diffInMS = new Date().getTime() - recordStartTime
      recordStartTime = null

      if (diffInMS <= delayBeforeStart && isFunctionType(binding.value.stopShortClick, vNode)) {
        binding.value.stopShortClick()
        return
      }

      if (timeout !== null) {
        clearTimeout(timeout)
      }

      if (isFunctionType(binding.value.stopClick, vNode)) {
        binding.value.stopClick()
      }

      timeout = setTimeout(() => {
        if (isFunctionType(binding.value.stopClickWithDelay, vNode)) {
          binding.value.stopClickWithDelay()
        }
      }, delayBeforeEnd)

      return false
    }

    /**
     * Cancel Context Menu
     * https://developer.mozilla.org/fr/docs/Web/API/Element/contextmenu_event
     * @param {Event} event
     * @return {Boolean} false
     */
    const ignoreMenu = event => {
      stopEventPropagation(event)
      return false
    }

    const stopEvents = ['click', 'mouseup', 'touchend', 'touchcancel']

    // In IE the mouseout event triggered even though the mouse pointer is still inside the element when animation occurs, so we opt out he
    // mouseout event from stopEvents
    if (!getUserAgentObject().isIEorEDGE) {
      stopEvents.push('mouseout')
    }

    // Listen to events and assign appropriate function
    ;['contextmenu'].forEach(event => el.addEventListener(event, ignoreMenu))
    ;['mousedown', 'touchstart', 'ontouchstart'].forEach(event => el.addEventListener(event, start))
    stopEvents.forEach(event => el.addEventListener(event, cancel))
  }
})
